import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  IconButton,
  Modal,
  TextField,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Close } from '@material-ui/icons';
import ActionButton from '../../../components/ActionButton';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(3),
    textAlign: 'center',
    backgroundColor: 'white',
    color: 'black',
    padding: theme.spacing(4),
    boxShadow: theme.shadows[6],
    borderRadius: '6px',
    overflowY: 'auto',
    width: '95%',
    maxWidth: '900px',
    maxHeight: '90vh',
  },
  spanTitle: {
    backgroundColor: theme.palette.grey[300],
    padding: '4px 8px',
    borderRadius: '8px',
    fontWeight: 600,
  },
  columnListContainer: {
    width: '100%',
    maxHeight: '50vh',
    overflowY: 'auto',
    paddingRight: theme.spacing(2), // per scrollbar
  },
  columnRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(1),
    backgroundColor: '#f5f5f5',
    borderRadius: '8px',
    marginBottom: theme.spacing(1),
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
}));

const CreazioneTabellaModal = ({
  colonneTabellaCustom,
  currentTabValue,
  handleAggiuntaTable,
  onAddColumn,
  onColumnChange,
  onClose,
  onDeleteColumn,
  open,
}) => {
  const classes = useStyles();

  return (
    <Modal open={open} onClose={onClose} className={classes.modal}>
      <div className={classes.modalContainer}>
        <Typography variant="h5">
          Creazione tabella per la sezione{' '}
          <span className={classes.spanTitle}>{currentTabValue.label}</span>
        </Typography>
        <Typography variant="h6">
          Cliccare su "Aggiungi colonna" per aggiungere una colonna alla tabella
        </Typography>
        <Box className={classes.columnListContainer}>
          {colonneTabellaCustom.map((item, index) => (
            <div key={index} className={classes.columnRow}>
              <TextField
                fullWidth
                value={item.header}
                onChange={(e) => onColumnChange(e, index)}
                variant="outlined"
                size="small"
                label="Nome colonna"
              />
              <IconButton size="small" onClick={() => onDeleteColumn(index)}>
                <Close />
              </IconButton>
            </div>
          ))}
        </Box>
        <div className={classes.buttonsContainer}>
          <ActionButton
            secondaryButton
            grayVersion={false}
            disabled={false}
            label="Aggiungi colonna"
            onClick={onAddColumn}
          />
          <ActionButton
            grayVersion={false}
            disabled={false}
            onClick={handleAggiuntaTable}
            label="Aggiungi Tabella"
          />
        </div>
      </div>
    </Modal>
  );
};

CreazioneTabellaModal.propTypes = {
  colonneTabellaCustom: PropTypes.array.isRequired,
  currentTabValue: PropTypes.object.isRequired,
  handleAggiuntaTable: PropTypes.func.isRequired,
  onAddColumn: PropTypes.func.isRequired,
  onColumnChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDeleteColumn: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default CreazioneTabellaModal;
